import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { translate, translateToHTML } from '../../../base/i18n/functions';
import Dialog from '../../../base/ui/components/web/Dialog';
import { cancelWaitForOwner } from '../../actions.web';
import Spinner from '../../../base/ui/components/web/Spinner';
import { IconExitPopup } from '../../../base/icons/svg';
/**
 * Authentication message dialog for host confirmation.
 *
 * @returns {React$Element<any>}
 */
class WaitForOwnerDialog extends PureComponent {
    /**
     * Instantiates a new component.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this._onCancelWaitForOwner = this._onCancelWaitForOwner.bind(this);
        this._onIAmHost = this._onIAmHost.bind(this);
    }
    /**
     * Called when the cancel button is clicked.
     *
     * @private
     * @returns {void}
     */
    _onCancelWaitForOwner() {
        const { dispatch } = this.props;
        dispatch(cancelWaitForOwner());
        //window.location.href = window.location.origin;
    }
    /**
     * Called when the OK button is clicked.
     *
     * @private
     * @returns {void}
     */
    _onIAmHost() {
        //this.props.dispatch(login());
        window.location.href = window.location.origin + '#login';
    }
    // @ts-ignore
    codiceStanzaPerVisualizzazione(roomName) {
        if (typeof roomName !== 'undefined') {
            if (roomName.length == 10) {
                return (roomName.substring(0, 3) +
                    " - " +
                    roomName.substring(3, 7) +
                    " - " +
                    roomName.substring(7));
            }
        }
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     */
    render() {
        const { t, dispatch
        // @ts-ignore
         } = this.props;
        let display = true;
        let us = localStorage.getItem("user");
        let room = window.location.pathname.substring(1) || undefined;
        //console.log("MS -----> Sono in WaitForOwnerDialog");
        let stanza = this.codiceStanzaPerVisualizzazione(room);
        return (React.createElement(Dialog, { cancel: { type: 'primary',
                icon: IconExitPopup,
                translationKey: this.props._alternativeCancelText ? 'dialog.WaitingForHostButton' : 'dialog.Cancel' }, disableBackdropClose: true, hideCloseButton: true, ok: this.props._hideLoginButton || localStorage.getItem("user") != null ? { hidden: true, disabled: true } : { translationKey: 'dialog.IamHost' }, 
            //ok = {{ hidden: true }} //MS nascosto di proposito
            onCancel: this._onCancelWaitForOwner, onSubmit: this._onIAmHost, titleKey: t('dialog.WaitingForHostTitle') },
            React.createElement("span", null, localStorage.getItem("user") != null ? translateToHTML(t, 'dialog.WaitForHostMsg', { stanza }) : translateToHTML(t, 'dialog.AreYouModerator', { stanza })),
            React.createElement("div", { style: { display: 'inline', padding: '10px' } },
                React.createElement(Spinner, null))));
    }
}
/**
 * Maps (parts of) the redux state to the associated
 * {@code WaitForOwnerDialog}'s props.
 *
 * @param {Object} state - The redux state.
 * @private
 * @returns {IProps}
 */
function mapStateToProps(state) {
    const { membersOnly, lobbyWaitingForHost } = state['features/base/conference'];
    const { hideLoginButton } = state['features/base/config'];
    return {
        _alternativeCancelText: membersOnly && lobbyWaitingForHost,
        _hideLoginButton: hideLoginButton
    };
}
export default translate(connect(mapStateToProps)(WaitForOwnerDialog));
